/**
 * 문제 은행에서 담은 문항을 지금 남은 칸에 맞춘다 — 모달을 연 뒤 목록이 늘었을 수 있다(AI 생성 결과 등).
 * 모달이 열릴 때 기억한 상한이 아니라 담는 순간의 문항 수로 다시 계산한다. 앞에서부터 남은 칸만큼 남긴다.
 */
export const fitQuizBankProblemsToRoom = <T>(
  problems: readonly T[],
  { currentCount, maxCount }: { currentCount: number; maxCount: number },
): { accepted: T[]; dropped: number } => {
  const room = Math.max(0, maxCount - currentCount);
  const accepted = problems.slice(0, room);
  return { accepted, dropped: problems.length - accepted.length };
};
